(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const messageContainer = document.querySelector('[data-m-c]');
    const variantDataElement = document.getElementById('VM');
    const translationDataElement = document.getElementById('Translations');
    const variantSelector = document.querySelector('[name="id"]'); 

    document.addEventListener('DOMContentLoaded', () => {
        if (!messageContainer || !variantDataElement || !translationDataElement || !variantSelector) return;
        
        const messages = JSON.parse(variantDataElement.textContent);
        const translations = JSON.parse(translationDataElement.textContent);

        console.log(messages);

        const PREORDER_TEXT = translations.preorder;
        const ADD_TO_CART_TEXT = translations.add_to_cart;

        const updateMessageAndButton = (variantId) => {
            const msg = messages[variantId];

            if (msg && msg.message?.trim() !== '') {
                messageContainer.textContent = msg.message;
                messageContainer.style.display = '';

                document.querySelector('.add-to-cart:not(.disabled) [data-js-product-add-to-cart-text]').textContent = PREORDER_TEXT;
            } else {
                messageContainer.textContent = '';
                messageContainer.style.display = 'none';

                document.querySelector('.add-to-cart:not(.disabled) [data-js-product-add-to-cart-text]').textContent = ADD_TO_CART_TEXT;
            }
        };

        variantSelector.addEventListener('change', (e) => {
          setTimeout(() => {  
            updateMessageAndButton(e.target.value);
          }, 50);
        });

        document.addEventListener('shopify:variant:change', (e) => {
          setTimeout(() => {  
            updateMessageAndButton(e.detail.variant.id);
          }, 50);
        });
        
        if (variantSelector.value) {
          setTimeout(() => {  
            updateMessageAndButton(variantSelector.value);
          }, 50);
        }
    });

    //Judge.me hide product name if review empty
    function runReviewCleanup() {
        const reviewElements = document.querySelectorAll('.jdgm-rev');

        reviewElements.forEach(review => {
            if (review.hasAttribute('data-cleanup-done')) {
                return;
            }

            const productTitle = review.getAttribute('data-product-title');

            if (productTitle) {
                const reviewBodyTextElement = review.querySelector('.jdgm-rev__body > p');

                if (reviewBodyTextElement) {
                    let currentText = reviewBodyTextElement.textContent.trim();
                    
                    const escapedTitle = productTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    const placeholderPattern = new RegExp(`${escapedTitle}`, 'i');

                    if (placeholderPattern.test(currentText)) {
                        const newText = currentText.replace(placeholderPattern, '').trim();
                        
                        reviewBodyTextElement.textContent = newText;
                        
                        if (newText === '') {
                            reviewBodyTextElement.remove();
                        }
                    }
                }
            }
            review.setAttribute('data-cleanup-done', 'true');
        });
    }

    document.addEventListener('DOMContentLoaded', runReviewCleanup);

    const targetNode = document.querySelector('.jdgm-rev-widg');
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if (mutation.target.closest('.jdgm-rev-widg')) {
                    setTimeout(runReviewCleanup, 100); 
                    break;
                }
            }
        }
    };

    if (targetNode) {
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

  } catch(e) { console.error(e); }
})();
})();
